import { TouchableOpacity, View } from 'react-native';
import { Text } from '@/components/Text';
import { DropDownItemType } from './types';
import { Icon } from '@/components/Icon';
import theme from '@/config/theme';
import { styles } from './Item.styles';

type DropdownItemProps = {
  item: DropDownItemType;
  onItemPress: (title: string) => void;
};

export const DropdownItem = ({ item, onItemPress }: DropdownItemProps) => {
  const { title, bold, iconName, iconColor, hide } = item;

  if (hide) {
    return null;
  }

  return (
    <TouchableOpacity
      activeOpacity={0.3}
      style={styles.item}
      onPress={() => onItemPress(title)}
      testID={`dropdown-item-${title}`}
    >
      <View style={styles.row}>
        {iconName ? (
          <Icon
            name={iconName}
            size={theme.fontSizes.xl}
            color={iconColor}
            style={styles.iconMargin}
          />
        ) : null}
        <Text style={bold ? styles.labelBold : styles.labelNormal}>
          {title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};
